import { createSelector } from "reselect";
import { adminSectionSelector } from "../../admin_section_selector";

export const adminRulesTabSelector = createSelector(
  adminSectionSelector,
  adminsSection => {
    return adminsSection.rulesTab;
  }
);
